module.exports = __webpack_public_path__ + "static/media/react.a7f9bac7.png";